<template>
  <li class="menu-item" :index="index" :class="classNames" @click="handleClick">
    <div :class="['menu-item__content', {'is_subitem' : isSubItem}]">
      <slot name="icon"></slot>
      <slot />
    </div>
  </li>
</template>

<script>
export default {
  name: 'EbMenuItem',
  props: {
    index: {
      default: null,
      validator: val => typeof val === 'string' || val === null,
    },
    route: [String, Object],
  },
  data() {
    return {
      isSubItem: false,
    };
  },
  inject: ['rootMenu'],
  computed: {
    active() {
      return this.index === this.rootMenu.activeIndex;
    },
    classNames() {
      return {
        active: this.active,
      };
    },
  },
  mounted() {
    this.checkItem();
  },
  methods: {
    handleClick() {
      this.rootMenu.$emit('item-click', this);
    },
    checkItem() {
      const parentComponentTag = this.$parent.$options._componentTag;
      if (parentComponentTag !== 'EbSubmenu') {
        return;
      }

      this.isSubItem = true;
    },
  },
};
</script>

<style lang="less">
@baseColor: var(--ui-base-font-color);
@activeColor: var(--ui-main-color);
@bgActiveColor: var(--ui-bg-color);

.menu-item {
  height: 48px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: @baseColor;
  padding: 0 0 0 20px;

  .eb-icon::before {
    color: @baseColor;
  }
  &.active {
    position: relative;
    background-color: @bgActiveColor;
    color: @activeColor;
    .eb-icon::before {
      color: @activeColor;
    }
  }
  .menu-item__content {
    position: relative;
    display: flex;
    align-items: center;
    &.is_subitem {
      // width: 100px;
      left: 0;
    }
  }
  .menu-item__bar {
    display: inline-block;
    width: 3px;
    height: 20px;
    margin-right: 20px;
    background-color: @baseColor;
  }
}
</style>
